import { TiSpin } from "@ti/ui-mobile";
import styled from "styled-components";

const PageCenter = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ThemeSpinner = () => {
  return (
    <PageCenter>
      <TiSpin size="middle" presetStyle="spin" />
    </PageCenter>
  );
};
export default ThemeSpinner;
